export const isNotFoundError = (error: any): boolean => error?.extensions?.statusCode === 404;
